import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useCustomStyles = makeStyles()((theme) => ({
	listBox: {
		maxHeight: `calc(${theme.list.item.height.small} * 5)`,
	},
}));
